<template>
  <div style="background-color:rgba(52,59,64,0.5) !important;padding:3px 10px;border-radius:25px;border:1px solid rgb(100,100,100);">
    <button v-for="language in languages" :key="language.lang" @click="changeLang(language.lang)" :style="[langAvailable.includes(language.lang) ? {cursor: 'pointer'} : {cursor: 'default'}]">
      <flag :iso="language.flag" :style="[language.lang === clang ? {opacity:0.8} : {opacity:0.2}]" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data: function () {
    return {
      languages: [
        {
          flag: 'FR',
          lang: 'fr',
          title: 'Français'
        },
        {
          flag: 'GB',
          lang: 'en',
          title: 'English'
        }
      ],
      clang: 'fr'
    }
  },
  computed: {
    filteredLanguage: function () {
      return this.languages.filter(item => {
        if (this.langAvailable.includes(item.lang)) {
          return true
        } else {
          return false
        }
      })
    },
    langAvailable: function () {
      var langA = ['fr']
      if (typeof this.$route.meta.titleen !== 'undefined') { langA.push('en') }
      return langA
    }
  },
  methods: {
    changeLang (lang) {
      if (this.langAvailable.includes(lang)) {
        this.$i18n.locale = lang
        this.clang = lang
      }
    }
  },
  watch: {
    langAvailable: function () {
      if (!this.langAvailable.includes(this.clang)) {
        this.clang = 'fr'
        this.$i18n.locale = 'fr'
      }
    }
  }
}
</script>

<style lang="css">
  button {
    background: none;
    padding-right: 5px;
    padding-left: 5px;
    border: 0px;
    font-size: 16px;
    margin: 0px;
    cursor: pointer;
  }
</style>
